import React from "react";

const CaretUp = (props: {className?: string}) => {
  return (<svg className={props.className ? props.className : undefined} xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" width="512" height="512"><path d="M6.41,16H17.59a1,1,0,0,0,.7-1.71L12.71,8.71a1,1,0,0,0-1.42,0L5.71,14.29A1,1,0,0,0,6.41,16Z"/></svg>)
}
export default CaretUp;
